import { render, staticRenderFns } from "./PersonItem.vue?vue&type=template&id=c6ff9172"
import script from "./PersonItem.vue?vue&type=script&lang=js"
export * from "./PersonItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports